export default __webpack_public_path__ + "static/media/service8.95b336d6.jpeg";